<template>
    <div class="guide-control-component-body g-bl" v-show="show">

        <div class="guide-control-component-body-content">
            <div class="guanbi-box">
                <i class="iconfont ad-guanbi guanbi-btn" @click="Close" />
            </div>

            <h1 class="gb-font">{{ title }}</h1>
            <div class="guide-item gb-card-select" v-for="(item, index) in buttonMenus" @click="item.action">
                <div class="left">
                    <span class="name gb-font">{{ item.name }}</span>
                    <span class="miaoshu">{{ item.miaoshu }}</span>
                </div>
                <div class="right">
                    <i class="item-icon iconfont ad-arrow-right-s-line"></i>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import GuideMenuButtonVO from '@/ts/vo/GuideMenuButtonVO';
import { ref } from 'vue';
const title = ref<string>("");
const buttonMenus = ref<GuideMenuButtonVO[]>([]);
const show = ref(false);

/**
 * 显示
 * @param _title 标题
 * @param _buttonMenus 按钮列表 
 */
function Show(_title: string, _buttonMenus: GuideMenuButtonVO[]) {
    title.value = _title;
    buttonMenus.value = _buttonMenus;
    show.value = true;
}

/**
 * 隐藏
 */
function Hide() {
    show.value = false;
}
/**
 * 关闭
 */
function Close() {
    Hide();
}

defineExpose({
    Show,
    Hide
});
</script>

<style lang="scss" scoped>
.guide-control-component-body {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 9999;
    height: 0px;
    width: 100%;
    height: 100%;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.8);


    .guide-control-component-body-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 20px;
        width: 100%;
        position: relative;

        .guanbi-box {
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: rgba($color: #ffff, $alpha: 0.4);

            .guanbi-btn {
                display: flex;
                position: absolute;
                // margin-bottom: 20px;
                bottom: -70px;
                // right: 15px;
                font-size: 60px;
                font-weight: bold;

            }
        }


        h1 {
            font-size: 40px;
        }

        .gb-font {
            font-size: 50px;
            margin-bottom: 20px;
        }

        .guide-item {
            display: flex;
            width: 100%;
            height: 180px;
            align-items: center;
            border-radius: 20px;
            padding: 0px 40px;
            margin: 10px 0px;

            .left {
                display: flex;
                flex-direction: column;
                height: 100%;
                justify-content: space-between;
                padding: 40px 0px;

                .name {
                    font-size: 40px;
                }

                .miaoshu {
                    font-size: 24px;
                }
            }

            .right {
                margin-left: auto;

                .item-icon {
                    font-size: 34px;
                }
            }
        }
    }
}
</style>